import { render, staticRenderFns } from "./TrackingInfoCard.vue?vue&type=template&id=2cfd2e9f&"
import script from "./TrackingInfoCard.vue?vue&type=script&lang=js&"
export * from "./TrackingInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports